import React, { useState, useEffect } from "react";
import {
  FaArrowLeft,
  FaStar,
  FaMapMarkerAlt,
  FaCheckCircle,
  FaUserClock,
  FaInfoCircle,
  FaCalendarAlt,
  FaEdit,
  FaFilePdf,
  FaFileWord,
  FaFileExcel,
  FaFileImage,
  FaFileAlt,
  FaEye,
  FaDownload,
  FaTimes,
} from "react-icons/fa";
import SummaryApi from "../common/index";

const InstructorProfile = () => {
  const [activeTab, setActiveTab] = useState("timeline");
  const [instructorData, setInstructorData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [showDocumentModal, setShowDocumentModal] = useState(false);
const [instructorCourses, setInstructorCourses] = useState([]);
 
    const fetchInstructorData = async () => {
      try {
        setLoading(true);
        const instructorId = sessionStorage.getItem("instructor_id");

        if (!instructorId) {
          setError("No instructor ID found in session storage");
          setLoading(false);
          return;
        }

        const response = await fetch(SummaryApi.instructorfulldetails.url, {
          method: SummaryApi.instructorfulldetails.method,
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ instructor_id: instructorId }),
        });

        const data = await response.json();

        if (data.status && data.data) {
          setInstructorData({
            ...data.data,
            documents: [
              data.data.document1,
              data.data.document2,
              data.data.document3,
              data.data.document4,
              data.data.document5,
            ].filter((doc) => doc && doc !== "N/A" && doc !== null),
          });
        } else {
          setError(data.message || "Failed to fetch instructor data");
        }
      } catch (error) {
        console.error("Error fetching instructor data:", error);
        setError("Error fetching instructor data");
      } finally {
        setLoading(false);
      }
    };
    useEffect(() => {
      fetchInstructorData();
      fetchInstructorCourses();
    }, []);


const fetchInstructorCourses = async () => {
  try {
    const instructorId = sessionStorage.getItem("instructor_id");
    
    if (!instructorId) {
      console.warn("No instructor ID found");
      return;
    }

    const response = await fetch(SummaryApi.getCourseIdByInstructorId.url, {
      method: SummaryApi.getCourseIdByInstructorId.method,
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ instructor_id: instructorId }),
    });

    const data = await response.json();
    
    if (data.status && data.data && Array.isArray(data.data)) {
      setInstructorCourses(data.data);
    } else {
      console.warn("No courses found for instructor:", data.message);
      setInstructorCourses([]);
    }
  } catch (error) {
    console.error("Error fetching instructor courses:", error);
    setInstructorCourses([]);
  }
};













  const handleEdit = () => {
    if (instructorData && instructorData.instructor_id) {
      sessionStorage.setItem(
        "edit_instructor_id",
        instructorData.instructor_id.toString()
      );

      const encodedId = btoa(instructorData.instructor_id.toString());
      window.open(
        `/instructor-panel/edit-instructor?id=${encodedId}`,
        "_blank"
      );
    }
  };

  const formatImageUrl = (imagePath) => {
    if (!imagePath) return "";
    if (imagePath.startsWith("http")) return imagePath;

    const baseUrl = SummaryApi.Images.url.replace("/api", "");

    if (imagePath.includes(baseUrl)) return imagePath;
    if (imagePath.startsWith("uploads/")) return `${baseUrl}/${imagePath}`;
    return `${baseUrl}/${imagePath}`;
  };

  const getDocumentIcon = (fileName) => {
    if (!fileName) return <FaFileAlt className="text-gray-500 dark:text-gray-400" />;

    const extension = fileName.split(".").pop().toLowerCase();

    switch (extension) {
      case "pdf":
        return <FaFilePdf className="text-red-500 dark:text-red-400" />;
      case "doc":
      case "docx":
        return <FaFileWord className="text-blue-500 dark:text-blue-400" />;
      case "xls":
      case "xlsx":
        return <FaFileExcel className="text-green-500 dark:text-green-400" />;
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
        return <FaFileImage className="text-purple-500 dark:text-purple-400" />;
      default:
        return <FaFileAlt className="text-gray-500 dark:text-gray-400" />;
    }
  };

  const getDocumentName = (documentUrl) => {
    if (!documentUrl) return "Document";
    return documentUrl.split("/").pop();
  };

  const handleViewDocument = (documentUrl) => {
    if (documentUrl) {
      const fullUrl = formatImageUrl(documentUrl);
      setSelectedDocument(fullUrl);
      setShowDocumentModal(true);
    }
  };

  const handleViewImage = () => {
    if (instructorData.instructor_image) {
      const fullUrl = formatImageUrl(instructorData.instructor_image);
      setSelectedDocument(fullUrl);
      setShowDocumentModal(true);
    }
  };

  const decodeHtmlEntities = (text) => {
    if (!text) return "";
    const textarea = document.createElement("textarea");
    textarea.innerHTML = text;
    return textarea.value;
  };

  const parseSkillsToBullets = (skills) => {
    if (!skills || skills === "N/A") return [];

    let decoded = decodeHtmlEntities(skills);

    let list = [];

    if (/<li>/i.test(decoded)) {
      const matches = decoded.match(/<li>(.*?)<\/li>/gi);
      if (matches) {
        list = matches.map((item) => item.replace(/<\/?li>/gi, "").trim());
      }
    }
    else if (decoded.includes(",")) {
      list = decoded
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
    }
    else if (decoded.includes("\n")) {
      list = decoded
        .split("\n")
        .map((s) => s.trim())
        .filter(Boolean);
    }
    else {
      const clean = decoded.trim();
      if (clean) list = [clean];
    }

    return list;
  };

  const handleDownloadDocument = (documentUrl, event) => {
    event.stopPropagation();

    if (documentUrl) {
      const fullUrl = formatImageUrl(documentUrl);
      const link = document.createElement("a");
      link.href = fullUrl;
      link.setAttribute("download", getDocumentName(documentUrl));
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const getSkills = (skillsHtml) => {
    if (!skillsHtml || skillsHtml === "N/A") return [];
    const skills = [];
    const liRegex = /<li>(.*?)<\/li>/g;
    let match;
    while ((match = liRegex.exec(skillsHtml)) !== null) {
      skills.push(match[1]);
    }
    return skills;
  };

  if (loading) {
    return (
      <div className="bg-white dark:bg-gray-900 min-h-screen font-sans flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 dark:border-blue-400 mx-auto"></div>
          <p className="mt-4 text-gray-600 dark:text-gray-300">Loading instructor data...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-white dark:bg-gray-900 min-h-screen font-sans flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-2">
            Error Loading Data
          </h2>
          <p className="text-gray-600 dark:text-gray-300">{error}</p>
        </div>
      </div>
    );
  }

  if (!instructorData) {
    return (
      <div className="bg-white dark:bg-gray-900 min-h-screen font-sans flex items-center justify-center">
        <div className="text-center">
          <p className="text-gray-600 dark:text-gray-300">No instructor data found</p>
        </div>
      </div>
    );
  }

  const formatTimeSlotsByDay = () => {
    const days = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];
    const timeSlotsByDay = {};

    days.forEach((day) => {
      timeSlotsByDay[day] = [];
      instructorData.time_slots.forEach((slot) => {
        const time = slot[day];
        if (time && time !== "N/A") {
          timeSlotsByDay[day].push({
            course_title: slot.course_title,
            time_range: time,
          });
        }
      });
    });

    return timeSlotsByDay;
  };

  const timeSlotsByDay = formatTimeSlotsByDay();

  const formatTime = (time) => {
    if (!time) return "N/A";
    const timeString = time.toString();
    const timeWithoutMicroseconds = timeString.split(".")[0];
    const parts = timeWithoutMicroseconds.split(":");
    if (parts.length < 2) return timeString;

    let hours = parseInt(parts[0]);
    const minutes = parts[1];
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;

    return `${hours}:${minutes} ${ampm}`;
  };

  const skillsList = parseSkillsToBullets(instructorData.skills);

  return (
    <div className="bg-white dark:bg-gray-900 min-h-screen font-sans text-gray-900 dark:text-gray-100">
      {/* Document Modal */}
      {showDocumentModal && (
        <div className="fixed inset-0 bg-black bg-opacity-70 dark:bg-opacity-80 flex items-center justify-center z-50 p-4">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-4xl w-full max-h-screen overflow-auto">
            <div className="flex justify-between items-center p-4 border-b border-gray-200 dark:border-gray-700">
              <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-100">Document Viewer</h3>
              <button
                onClick={() => setShowDocumentModal(false)}
                className="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 text-xl"
              >
                <FaTimes />
              </button>
            </div>
            <div className="p-4 flex justify-center">
              {selectedDocument &&
                (selectedDocument.match(/\.(jpg|jpeg|png|gif)$/i) ? (
                  <img
                    src={selectedDocument}
                    alt="Preview"
                    className="max-w-full max-h-[600px] object-contain rounded-lg shadow-md"
                  />
                ) : (
                  <iframe
                    src={selectedDocument}
                    className="w-full h-96"
                    title="Document Viewer"
                    frameBorder="0"
                  />
                ))}
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <div className="bg-[#0A3A74] dark:bg-[#0A2A5A] text-white px-6 py-4 flex items-center justify-between">
        <h1 className="text-2xl font-bold">Instructor Profile</h1>
        <button
          onClick={handleEdit}
          className="bg-white dark:bg-gray-200 text-[#0A3A74] dark:text-[#0A2A5A] px-4 py-1 rounded-md flex items-center gap-2 hover:bg-blue-50 dark:hover:bg-gray-300 transition-colors"
        >
          <FaEdit /> Edit Profile
        </button>
      </div>

      {/* Main Content */}
      <div className="px-6 md:px-10 py-8 space-y-8">
        {/* Image + Profile Details + Work + Skills */}
        <div className="flex flex-col lg:flex-row items-start gap-8">
          {/* Left Column: Image + Work + Skills + Documents */}
          <div className="flex flex-col items-center lg:items-start space-y-6 w-full max-w-3xl mx-auto">
            {/* Instructor Image */}
            <div className="flex-shrink-0 relative">
              {instructorData.instructor_image ? (
                <>
                  <img
                    src={formatImageUrl(instructorData.instructor_image)}
                    alt="Instructor"
                    className="rounded-lg w-80 h-80 object-cover shadow-md cursor-pointer"
                    onClick={handleViewImage}
                  />
                </>
              ) : (
                <div className="rounded-lg w-80 h-80 bg-gray-200 dark:bg-gray-700 flex items-center justify-center shadow-md">
                  <svg
                    className="w-32 h-32 text-gray-400 dark:text-gray-500"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </div>
              )}
            </div>

            {/* WORK Section */}
            <div className="flex flex-col lg:text-left w-full max-w-2xl">
              <div className="flex my-4">
                <h3 className="text-gray-700 dark:text-gray-300 font-semibold tracking-wide mr-3">
                  WORK
                </h3>
                <div className="flex-1 border-t border-gray-300 dark:border-gray-600 w-32"></div>
              </div>

              <h4 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mt-2">
                {instructorData.job_title !== "N/A"
                  ? instructorData.job_title
                  : "Not Specified"}
              </h4>
<div className="mt-6">
  <h4 className="text-lg font-semibold text-gray-800 dark:text-gray-100 mb-4">
    About the Instructor
  </h4>

  <div className="space-y-2">
    {[...(instructorData.about_instructor1 || "")
        .split(".")
        .filter(s => s.trim()),
      ...(instructorData.about_instructor2 || "")
        .split(".")
        .filter(s => s.trim())
    ].map((sentence, index) => (
      <div key={index} className="flex items-start gap-3">
        <span className="flex-shrink-0 w-1.5 h-1.5 mt-2 bg-blue-600 dark:bg-cyan-400 rounded-full"></span>
        <p className="text-gray-700 dark:text-gray-200 leading-relaxed">
          {sentence.trim()}.
        </p>
      </div>
    ))}
  </div>

  {/* Fallback */}
  {(!instructorData.about_instructor1 || instructorData.about_instructor1 === "N/A") &&
    (!instructorData.about_instructor2 || instructorData.about_instructor2 === "N/A") && (
    <p className="text-gray-500 dark:text-gray-400 italic mt-4">
      No information provided yet.
    </p>
  )}
</div>

              {instructorData.about_instructor1 === "N/A" &&
                instructorData.about_instructor2 === "N/A" && (
                  <p className="text-gray-600 dark:text-gray-400 text-sm leading-relaxed">
                    No work information available
                  </p>
                )}
            </div>

            <div className="flex items-center w-full my-4">
              <h3 className="text-gray-700 dark:text-gray-300 font-semibold tracking-wide mr-3 whitespace-nowrap">
                SKILLS
              </h3>
              <div className="flex-1 border-t border-gray-300 dark:border-gray-600 w-32"></div>
            </div>

            {skillsList.length > 0 ? (
              <ul className="mt-4 space-y-2 text-gray-700 dark:text-gray-200 font-medium list-disc list-inside">
                {skillsList.map((skill, index) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: skill }} />
                ))}
              </ul>
            ) : (
              <p className="text-gray-600 dark:text-gray-400 italic">No skills specified</p>
            )}

            {/* DOCUMENTS Section */}
            <div className="flex items-center w-full my-4">
              <h3 className="text-gray-700 dark:text-gray-300 font-semibold tracking-wide mr-3 whitespace-nowrap">
                DOCUMENTS
              </h3>
              <div className="flex-1 border-t border-gray-300 dark:border-gray-600 w-32"></div>
            </div>

            {instructorData.documents && instructorData.documents.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 w-full">
                {instructorData.documents.map((doc, index) => {
                  const isImage =
                    doc && /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(doc);

                  return (
                    <div
                      key={index}
                      className="flex items-center justify-between p-2 bg-gray-50 dark:bg-gray-800 rounded-md hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors cursor-pointer w-full"
                      onClick={() => isImage && handleViewDocument(doc)}
                    >
                      <div className="flex items-center space-x-2">
                        <span>{doc ? "✔️" : "N/A"}</span>
                        <span className="text-sm text-gray-700 dark:text-gray-300">{`Document ${
                          index + 1
                        }`}</span>
                      </div>
                      {doc && (
                        <div
                          className="flex space-x-2"
                          onClick={(e) => e.stopPropagation()}
                        >
                          {isImage && (
                            <button
                              onClick={() => handleViewDocument(doc)}
                              className="p-1 text-blue-500 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300"
                              title="View Document"
                            >
                              <FaEye />
                            </button>
                          )}
                          <button
                            onClick={(e) => handleDownloadDocument(doc, e)}
                            className="p-1 text-green-500 dark:text-green-400 hover:text-green-700 dark:hover:text-green-300"
                            title="Download Document"
                          >
                            <FaDownload />
                          </button>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            ) : (
              <p className="text-gray-600 dark:text-gray-400">No documents available</p>
            )}
          </div>

          {/* Right Column: Profile + Tabs + Tab Contents */}
          <div className="flex-1 flex flex-col space-y-6">
            {/* Profile Details */}
            <div className="flex flex-col text-center lg:text-left space-y-2">
              <h2 className="text-3xl font-bold text-gray-800 dark:text-gray-100">
                {instructorData.first_name} {instructorData.last_name}
              </h2>
              <p className="text-blue-600 dark:text-blue-400 font-medium">
                {instructorData.job_title !== "N/A"
                  ? instructorData.job_title
                  : "Instructor"}
              </p>
              <p className="text-gray-500 dark:text-gray-400 flex items-center gap-1 justify-center lg:justify-start">
                <FaMapMarkerAlt />{" "}
                {instructorData.address !== "N/A"
                  ? instructorData.address
                  : "Location not specified"}
              </p>

              {/* Rating */}
              <div className="flex items-center space-x-2 justify-center lg:justify-start">
                <FaStar className="text-yellow-500 dark:text-yellow-400 text-xl" />
                <span className="text-lg font-semibold text-gray-800 dark:text-gray-100">
                  {instructorData.rating}
                </span>
                <span className="text-gray-600 dark:text-gray-400">(reviews)</span>
              </div>

              {/* Action Buttons */}
              <div className="flex gap-3 flex-wrap justify-center lg:justify-start">
                <button className="bg-[#E7F0FF] dark:bg-[#1E3A5F] text-[#0A3A74] dark:text-white px-4 py-1 rounded-md text-sm font-medium hover:bg-blue-100 dark:hover:bg-[#2A4A7F]">
                  Send Message
                </button>
                <button className="bg-[#E7F0FF] dark:bg-[#1E3A5F] text-[#0A3A74] dark:text-white px-4 py-1 rounded-md text-sm font-medium hover:bg-blue-100 dark:hover:bg-[#2A4A7F]">
                  Contact
                </button>
                <button className="bg-[#F3F4F6] dark:bg-gray-700 text-gray-800 dark:text-gray-200 px-4 py-1 rounded-md text-sm font-medium hover:bg-gray-200 dark:hover:bg-gray-600">
                  Report User
                </button>
              </div>
            </div>

            {/* Tabs */}
            <div className="flex items-center justify-start border-b border-gray-300 dark:border-gray-700 text-gray-600 dark:text-gray-300 font-medium gap-12">
              <div className="pb-2 flex items-center gap-2 text-[#0A3A74] dark:text-[#4A9EFF] border-b-2 border-[#0A3A74] dark:border-[#4A9EFF] cursor-default w-[30%]">
                <FaCalendarAlt /> Class Schedules
              </div>
              <button
                onClick={() => setActiveTab("about")}
                className={`pb-2 flex items-center gap-2 ${
                  activeTab === "about"
                    ? "border-b-2 border-[#0A3A74] dark:border-[#4A9EFF] text-[#0A3A74] dark:text-[#4A9EFF]"
                    : "hover:text-[#0A3A74] dark:hover:text-[#4A9EFF]"
                }`}
              >
                <FaInfoCircle /> About
              </button>
            </div>

{/* Tab Contents */}
<div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-4">
  {/* Class Schedule */}
  <div className="px-2 py-4 rounded-lg">
    {Object.entries(timeSlotsByDay).map(([day, slots]) => {
      if (slots.length === 0) return null;

      return (
        <div
          key={day}
          className="bg-[#E7F0FF] dark:bg-[#1E3A5F] rounded-lg p-3 mb-2 w-full" // Added w-full
        >
          {/* Day and Time in column layout */}
          <div className="flex flex-col w-full"> {/* Changed to flex-col */}
            {/* Day */}
            <div className="flex items-center gap-2 mb-2"> {/* Added mb-2 for spacing */}
              <FaCheckCircle className="text-orange-500 dark:text-orange-400 text-[12px] flex-shrink-0" />
              <span className="text-[12px] font-bold text-gray-700 dark:text-gray-200 capitalize">
                {day}
              </span>
            </div>
            
            {/* Time Slots */}
            <div className="space-y-1 w-full"> {/* Added space-y-1 and w-full */}
              {slots.map((slot, index) => (
                <div
                  key={index}
                  className="text-[#0A3A74] dark:text-[#4A9EFF] font-medium text-[10px] w-full"
                >
                  <div className="text-[10px] text-gray-600 dark:text-gray-400 w-full break-words"> {/* Added break-words */}
                    {slot.course_title}
                  </div>
                  <div className="w-full break-words"> {/* Added break-words */}
                    {formatTime(slot.time_range.split("-")[0])} –{" "}
                    {formatTime(slot.time_range.split("-")[1])}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    })}

    {instructorData.time_slots.length === 0 && (
      <p className="text-gray-500 dark:text-gray-400 text-center">
        No class schedules found
      </p>
    )}
  </div>

  {/* About */}
  {activeTab === "about" && (
    <div className="px-4 py-6 rounded-lg col-span-2">
      <p>
        <strong className="text-gray-700 dark:text-gray-300">Phone :</strong>{" "}
        <span className="text-blue-700 dark:text-blue-400">
          {instructorData.mobile_number !== "N/A"
            ? instructorData.mobile_number
            : "N/A"}
        </span>
      </p>
      <p className="mt-2">
        <strong className="text-gray-700 dark:text-gray-300">Alternate Phone :</strong>{" "}
        <span className="text-blue-700 dark:text-blue-400">
          {instructorData.alternate_mobile_number !== "N/A"
            ? instructorData.alternate_mobile_number
            : "N/A"}
        </span>
      </p>
      <p className="mt-2">
        <strong className="text-gray-700 dark:text-gray-300">Address :</strong>{" "}
        {instructorData.address !== "N/A"
          ? instructorData.address
          : "N/A"}
      </p>
      <p className="mt-2">
        <strong className="text-gray-700 dark:text-gray-300">E-mail :</strong>{" "}
        <span className="text-blue-700 dark:text-blue-400">
          {instructorData.email}
        </span>
      </p>
      <p className="mt-2">
        <strong className="text-gray-700 dark:text-gray-300">Site :</strong>{" "}
        <a
          href={
            instructorData.website !== "N/A"
              ? instructorData.website
              : "#"
          }
          className="text-blue-700 dark:text-blue-400 underline hover:text-blue-800 dark:hover:text-blue-300"
        >
          {instructorData.website !== "N/A"
            ? instructorData.website
            : "N/A"}
        </a>
      </p>
      <p className="mt-2">
        <strong className="text-gray-700 dark:text-gray-300">Qualification :</strong>{" "}
        {instructorData.qualification !== "N/A"
          ? instructorData.qualification
          : "N/A"}
      </p>
      <p className="mt-2">
        <strong className="text-gray-700 dark:text-gray-300">University :</strong>{" "}
        {instructorData.study_university !== "N/A"
          ? instructorData.study_university
          : "N/A"}
      </p>
      <p className="mt-2">
        <strong className="text-gray-700 dark:text-gray-300">Experience :</strong>{" "}
        {instructorData.total_experience !== "N/A"
          ? instructorData.total_experience
          : "N/A"}
      </p>
              <div className="mt-4">
          <strong className="text-gray-700 dark:text-gray-300">Courses Teach:</strong>
          {instructorCourses.length > 0 ? (
            <div className="mt-2 flex flex-wrap gap-2">
              {instructorCourses.map((course, index) => (
                <span 
                  key={index} 
                  className="bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 px-3 py-1 rounded-full text-sm"
                >
                  {course.course_title || course.course_name || `Course ${index + 1}`}
                </span>
              ))}
            </div>
          ) : (
            <span className="ml-2 text-gray-500 dark:text-gray-400">No courses assigned</span>
          )}
        </div>
    </div>
  )}
</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstructorProfile;



